import React, { useMemo } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// Theme
import { themeSettings } from "theme";

// Scenes
import {
  Layout,
  Dashboard,
  Products,
  Customers,
  Yogas,
  Transactions,
  Geography,
  Overview,
  Daily,
  Monthly,
  Breakdown,
  Admin,
  Performance,
} from "scenes";

import Religions from "scenes/religion";
import Language from "scenes/language";
import ContactUsCategories from "scenes/contact_us_categories";
import UserActivityCategories from "scenes/user_activity_categories";
import UserInterestCategories from "scenes/user_interest_categories";
import ServiceProviderCategories from "scenes/service_provider_categories";
import CreateRequestCategories from "scenes/create_request_categories";
import CreateGoalCategories from "scenes/goal_categories";
import Login from "scenes/login";
import { useState } from "react";
import ReportedCustomers from "scenes/ReportedCustomers";
import ReportedCustomerDetail from "scenes/ReportedCustomerDetails";
import WebsiteInterest from "scenes/website_interests";
import CustomerSubscriptionDetails from "scenes/customer_subscription_details";
import YogaEmpowerCategories from "scenes/YogaEmpowerCategories";
import Coupons from "scenes/coupon";

// App
const App = () => {
  const userData = JSON.parse(localStorage.getItem('user_data'));

  // Dark/Light mode
  const mode = useSelector((state) => state.global.mode);
  // theme setting
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = (isSuccessful) => {
    if (isSuccessful) {
      setIsLoggedIn(true); // For demonstration, setting isLoggedIn to true
    } else {
      setIsLoggedIn(false); // For demonstration, setting isLoggedIn to true
    }

  };

  return (
    <div className="app">
      <BrowserRouter>
        {/* Theme Provider */}
        <ThemeProvider theme={theme}>
          <CssBaseline />
           <Toaster position="bottom-center" toastOptions={{ duration: 2000 }} />
          <Routes>


            {
              userData == null ?
                <Route>
                  <Route path="/login" element={<Login onLogin={handleLogin} />} />
                  <Route path="/*" element={<Navigate to="/login" replace />} />
                </Route>
                : <Route element={<Layout />}>
                  {/* <Route path="/" element={<Navigate to="/dashboard" replace />} /> */}
                  <Route path="/" element={<Navigate to="/users" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/products" element={<Products />} />
                  {/* <Route path="/customers" element={<Customers />} /> */}
                  <Route path="/users" element={<Customers />} />
                  <Route path="/reportedUsers" element={<ReportedCustomers />} />
                  <Route path="/reportedUserDetails" element={<ReportedCustomerDetail />} />
                  <Route path="/emoEase" element={<Yogas />} />
                  <Route path="/transactions" element={<Transactions />} />
                  <Route path="/geography" element={<Geography />} />
                  <Route path="/overview" element={<Overview />} />
                  <Route path="/daily" element={<Daily />} />
                  <Route path="/monthly" element={<Monthly />} />
                  <Route path="/breakdown" element={<Breakdown />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/performance" element={<Performance />} />
                  <Route path="/religion" element={<Religions />} />
                  <Route path="/language" element={<Language />} />
                  <Route path="/language" element={<Language />} />
                  <Route path="/contactUsCategories" element={<ContactUsCategories />} />
                  <Route path="/userActivityCategories" element={<UserActivityCategories />} />
                  <Route path="/userInterestCategories" element={<UserInterestCategories />} />
                  <Route path="/serviceProviderCategories" element={<ServiceProviderCategories />} />
                  <Route path="/createRequestCategories" element={<CreateRequestCategories />} />
                  <Route path="/goalCategories" element={<CreateGoalCategories />} />
                  <Route path="/websiteInterest" element={<WebsiteInterest />} />
                  <Route path="/subscriptionDetails" element={<CustomerSubscriptionDetails/>} />
                  <Route path="/yogaEmpowerCategories" element={<YogaEmpowerCategories />} />
                  <Route path="/coupons" element={<Coupons />} />
                </Route>
            }
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
